import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery } from "react-query"
import axios from "src/shared/axios"

type PersonalRoom = {
  roomId: string
  name: string
  audienceHash: string
  broadcasterHash: string
  moderatorHash: string
  enableCountdownTimer: string
  countdownDateTime: string
  countdownTimeZone: boolean
  countdownTimeUTC: string
  thumbnailUrl: string
  isExpired: boolean
}

const QUERY_KEY = "personal_room"

export function usePersonalRoom() {
  const { data } = useQuery({
    queryKey: [QUERY_KEY],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const meetingClient = await sdkContextStatus
      const url = new URL(meetingClient?.envConfig.PERSONAL_ROOM_URL)
      try {
        const response = await axios.get(url.toString(), {
          withCredentials: true
        })
        return response.data
      } catch (err) {
        console.error(err)
        throw err
      }
    }
  })

  return { personalRoom: data?.room as PersonalRoom }
}
